var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFavicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 98,
    viewBox: "0 0 65 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1",
    clipPath: "url(#clip0_2_45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.3333 98C28.3333 98 -20.427 80.6142 9.98487 26.5763C9.98487 26.5763 7.11264 45.3477 12.1306 56.6798C17.1485 68.0119 24.0419 77.6945 28.3333 98Z",
    fill: "url(#paint0_linear_2_45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M36.6667 98C42.4485 95.8869 47.7239 92.5954 52.1552 88.336C57.0647 83.6461 60.7881 77.8644 63.0201 71.4648C65.6089 63.153 65.6601 54.2628 63.1672 45.922C61.5567 39.578 58.7876 33.5832 54.9981 28.2373C55.8404 36.9936 54.9919 45.8295 52.4984 54.2682C50.2764 61.5893 47.793 64.9571 44.0352 74.1492C40.8889 81.8716 38.4234 89.8519 36.6667 98Z",
    fill: "url(#paint1_linear_2_45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M32.7034 81.3898C34.432 81.3898 35.535 77.684 38.6629 69.5939C40.6713 64.4156 41.478 63.0921 42.3505 60.5774C43.3671 57.8371 44.1923 55.0288 44.8199 52.173C47.342 41.1982 47.28 29.7832 44.6388 18.8368C43.2152 14.16 41.077 9.73407 38.3007 5.71732C35.749 2.01146 34.4649 0.158521 32.6047 0.00962471C27.6659 -0.387433 22.4144 11.5905 20.2248 19.3C17.4723 30.6215 17.7278 42.471 20.9656 53.662C22.151 57.2521 23.7972 61.537 23.7972 61.537C25.0154 64.6803 25.7233 65.7226 27.172 69.5939C29.9707 77.2042 30.8926 81.3567 32.7034 81.3898Z",
    fill: "url(#paint2_linear_2_45)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_45",
    x1: 0.320668,
    y1: 41.7023,
    x2: 33.8597,
    y2: 95.0047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#631101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#BB1E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F95C04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FEB400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9D776"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_45",
    x1: 65.7813,
    y1: 40.2278,
    x2: 32.1975,
    y2: 93.5728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#631101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#BB1E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F95C04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FEB400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#E9D776"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_45",
    x1: 32.473,
    y1: 10.1677,
    x2: 32.473,
    y2: 91.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#631101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#BB1E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F95C04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FEB400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9D776"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_45"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 98,
    fill: "white"
  })))));
}

export default __webpack_public_path__ + "media/b955bc80.svg";
export { SvgFavicon as ReactComponent };